import axios from "axios"

const DireccionService = {
  getDireccionEmpresaById(id: $TSMigrationFixMe) {
    return axios.get(`/Direccion/empresa/${id}`)
  },

  getDireccionFiscalEmpresaById(id: $TSMigrationFixMe) {
    return axios.get(`/Direccion/empresa/${id}/fiscal`)
  },

  insertDireccion(direccion: $TSMigrationFixMe) {
    return axios.post(`/Direccion`, direccion)
  },

  updateDireccion(direccion: $TSMigrationFixMe) {
    return axios.put(`/Direccion/${direccion.id}`, direccion)
  },

  deleteDireccion(direccionId: $TSMigrationFixMe) {
    return axios.delete(`/Direccion/${direccionId}`)
  },
  getMapCoordinates(postalCode: $TSMigrationFixMe) {
    return axios.get(
      `https://nominatim.openstreetmap.org/search.php?country=es&postalcode=${postalCode}&countrycodes=es&limit=1&format=jsonv2`
    )
  },
}

export default DireccionService
